export default {
  getRestrictions: state => state.items
}



// WEBPACK FOOTER //
// ./src/store/modules/restrictions/getters.js